export const SET_PAYMENT_TOKENS = 'pymt/user/set_tokens';
export const SET_PAYMENT_LOADING = 'pymt/system/payment_loading';
export const SET_PAYMENT_SUCCESS = 'pymt/system/payment_success';
